// Libs
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { SingleIconPieChart } from '@/components/composite/Charts/SingleIconPieChart';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';

export const lostFansPerSourceConfig: ChartType<typeof SingleIconPieChart> = {
    title: 'chart.facebook.lost_fans_per_source',
    name: {
        other: 'other',
        deactivated_or_memorialized_account_removals:
            'deactivated_or_memorialized_account_removals',
        suspicious_account_removals: 'suspicious_account_removals',
        unlikes_from_page_posts_or_news_feed: 'unlikes_from_page_posts_or_news_feed',
        unlikes_from_search: 'unlikes_from_search'
    },
    deprecated: { status: '03/14/2024' },
    id: 'lost_fans_per_source',
    icon: 'followers',
    social: FACEBOOK,
    valueFormat: classicFormat,
    color: {
        other: 'gray',
        deactivated_or_memorialized_account_removals: 'lightorange',
        suspicious_account_removals: 'orange',
        unlikes_from_page_posts_or_news_feed: 'red',
        unlikes_from_search: 'lightred'
    },
    size: SIZE_50,
    type: 'chart',
    element: SingleIconPieChart,
    tooltipTranslation: {
        token: 'chart.facebook.lost_fans_per_source_tooltip_translation',
        values: ['name', 'value', 'percentage']
    }
};
